module.exports = __webpack_public_path__ + "img/962d571.jpg";